export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export const mq = {
  sm: `@media (min-width: ${breakpoints.sm}px)`,
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
} as const;

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
} as const;

export const fontFamilies = {
  display: "'Saira', sans-serif",
  ui: "'Rubik', -apple-system, system-ui, 'Segoe UI', Helvetica, Arial, sans-serif",
  mono: "Monaco, Menlo, 'Ubuntu Mono', monospace",
} as const;

export const fontSizes = {
  micro: '0.625rem',
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.25rem',
  xl: '1.5rem',
  xxl: '1.875rem',
  xxxl: '2rem',
  display2: '3.75rem',
  display1: '5.5rem',
} as const;

export const fontWeights = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const radii = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  button: '13px',
  pill: '18px',
  round: '50%',
} as const;

export const shadows = {
  insetButton: 'rgba(22, 15, 36, 0.15) 0px 1px 3px 0px inset',
  surface: 'rgba(22, 15, 36, 0.12) 0px 2px 8px',
  elevated: 'rgba(22, 15, 36, 0.15) 0px 10px 15px -3px',
  prominent: 'rgba(22, 15, 36, 0.25) 0px 0.5rem 1.5rem',
  ambient: 'rgba(22, 15, 36, 0.9) 0px 4px 4px 9px',
} as const;

export const glass = {
  backdrop: 'blur(18px) saturate(180%)',
  bg: 'rgba(255, 255, 255, 0.18)',
  bgHover: 'rgba(54, 22, 107, 0.14)',
} as const;

export const layout = {
  sidebarWidth: '240px',
  sidebarCollapsedWidth: '64px',
  topbarHeight: '56px',
  inspectorWidth: '320px',
  inspectorWidthXl: '360px',
  inspectorTabWidth: '24px',
} as const;
